import { Link, useNavigation } from '@remix-run/react'

import { useClientEnv } from '~/utils/client/hooks/useClientEnv'

import {
  Button,
  Card,
  SplitPageLayout,
  Steps,
  CircularStepVertical,
  Info,
  Title,
  Paragraph,
} from '~/components'
import type { PageHandle } from '~/components/convenience/PageHandle'
import { UsersIcon, ShieldCheckIcon, LockClosedIcon } from '@heroicons/react/20/solid'
import { route } from 'routes-gen'
import { i18n } from '@lingui/core'

export const handle: PageHandle = {
  bodyClassName: 'h-screen bg-surface flex flex-col',
}

export default function RegisterStartRoute() {
  const navigation = useNavigation()
  const clientEnv = useClientEnv()

  return (
    <SplitPageLayout image={`${clientEnv.publicPath}/images/skyscraper.jpg`}>
      <main className="flex w-full flex-col flex-1 items-center justify-center">
        <Card className="my-6">
          <Title className="mb-4">{i18n._('Erstanmeldung')}</Title>
          <Paragraph className="mb-1 text-brand font-semibold">
            {i18n._('Herzlich willkommen!')}
          </Paragraph>
          <Paragraph>
            {i18n._(
              'Sie müssen nun folgende Schritte durchführen, um die Anmeldung vollständig abzuschließen.'
            )}
          </Paragraph>
          <Steps className="my-8" vertical>
            <CircularStepVertical
              title={i18n._('Eingabe Ihres Loginnamens')}
              description={i18n._('Es wird geprüft, ob Ihr Loginname gefunden werden kann.')}
              icon={UsersIcon}
            />
            <CircularStepVertical
              title={i18n._('Identifikation')}
              description={i18n._(
                'Um sicherzustellen, dass Sie berechtigt sind, prüfen wir ein paar zuvor angegebene Daten von Ihnen ab.'
              )}
              icon={ShieldCheckIcon}
            />
            <CircularStepVertical
              title={i18n._('Passwortvergabe')}
              description={i18n._(
                'Zuletzt können Sie ein neues Passwort vergeben. Dieses wird zukünftig für Ihren Zugang gültig sein.'
              )}
              icon={LockClosedIcon}
              isLastStep
            />
          </Steps>
          <Button
            as={Link}
            to={route('/erstanmeldung/schritt/anmeldung')}
            align="left"
            variant="primary"
            label={i18n._('Starten')}
            loading={navigation.state !== 'idle'}
            className="w-full md:w-40"
          />
        </Card>
        <Card className="" variant="info">
          <Info>
            {i18n._(
              'Sofern Sie Zweifel an der Richtigkeit dieser Seite hegen sollten, zögern Sie nicht uns zu kontaktieren und wenden Sie sich per Mail an'
            )}{' '}
            <a className="text-brand font-bold" href="mailto:feedback@bpam.lu">
              feedback@bpam.lu
            </a>{' '}
            {i18n._('oder per Telefon unter der deutschen Festnetz-Rufnummer')}{' '}
            <a className="text-brand font-bold" href="tel:+89889498525">
              089 - 88 949 85 25
            </a>{' '}
            {i18n._(
              'direkt an uns. Sie erreichen uns unter dieser Nummer zu den üblichen Geschäftszeiten.'
            )}
          </Info>
        </Card>
      </main>
    </SplitPageLayout>
  )
}
